import {MappingOrigin} from "./mappingOrigin";

export class ImportContainer {
    constructor(
        public id?: string,
        public name?: string,
        public dataSourceId?: string,
        public logoLink?: string,
        public createdByUserId?: string,
        public lastChanged?: Date,
        public productCount?: number,
        public catalogIds?: string[],
        public note?: string,
        public activeCatalogId?: string,
        public compareCatalogId?: string,
        public workflowId?: string,
        public otherMappingsToExecute: string[] = [],
        public categoryMappings: { [importGroupString: string]: string } = {},
        public responsibleFirstName?: string,
        public responsibleLastName?: string,
        public responsiblePhone?: string,
        public responsibleEmail?: string,
        public dataSourceTags: string[] = [],
        public categoryMappingOrigins: { [importGroupString: string]: MappingOrigin } = {},
        public lastCatalogImport?: Date
    ) {
    }
}
